<template>
  <div>
    <WhatsAppConnect :type="'FINANCE'" :rest_home_id="rest_home_id" />
  </div>
</template>

<script>
import WhatsAppConnect from "../WhatsApp/WhatsAppConnect";

export default {
  name: "WhatsApp",

  components: {
    WhatsAppConnect,
  },

  props: { rest_home_id: Number },
};
</script>

